<template>
  <t-default-lp-layout>
    <div :class="componentClassName">
      <section id="lp-about-section" class="t-landing__section">
        <p align="center">
          <br />
          本サイトは移転しました。<br />
          以下のリンクをクリックして下さい。<br />
          <a
            id="new-site-url"
            href="https://www.ntt.com/business/services/voice-visual-communication/callcenter-ivr/ccaas/lp/03_da.html"
            >こちらをクリック</a
          >
        </p>
      </section>
    </div>
  </t-default-lp-layout>
</template>

<script>
import TDefaultLpLayout from '@/components/templates/default-lp-layout';

export default {
  name: 't-landing',
  components: {
    TDefaultLpLayout,
  },
};
</script>
